import React, { useState, useEffect } from "react";
import { Modal, Tooltip } from "antd";
import { Apartment, Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelAlgo,
  completeAlgo,
  setAlgoPreview,
  setLastUpdated,
  updateAlgo,
} from "../../../../../store/actions/algo";
import { setSubmissionError } from "../../../../../store/actions/app";
import CancelTargetListModal from "./cancel-target-list";

const TargetListCompaniesProgresstModal = ({
  preview,
  previewHandler,
  isListGenerating,
}) => {
  // STATES
  const [cancelPreview, setCancelPreview] = useState(false);
  const [selectedAlgo, setSelectedAlgo] = useState(null);

  // CONST VALS
  const { http } = global.services;
  const dispatch = useDispatch();

  // REDUX DATA
  const user = useSelector((state) => state.UserReducer.profile);
  const userCompanies = useSelector((state) => state.CompanyReducer.companies);
  const selectedCompany = useSelector((state) => state.CompanyReducer.selected_company);
  const { companies: agloCompanies } = useSelector((state) => state.algoReducer);

  // HELPERS
  const getAlgorithmStatus = (company_id, fromInterval, onResponse = () => {}) => {
    http
      .get(`algo-status`)
      .then(({ data }) => {
        const selectedCompany = data?.find((item) => item.company === company_id);

        if (selectedCompany.status === "failed" && fromInterval) {
          const isOwner = selectedCompany?.user === user?.id;
          if (isOwner) dispatch(setSubmissionError(true));
        }

        data.forEach((algo) => {
          if (algo.status === "failed" && fromInterval) {
            dispatch(completeAlgo({ companyId: algo.company }));
          }

          if (algo.status === "cancelled" && fromInterval) {
            dispatch(cancelAlgo({ companyId: algo.company }));
          }

          if (algo.status === "completed" && fromInterval) {
            dispatch(completeAlgo({ companyId: algo.company }));
          }

          if (algo.status === "processing") {
            dispatch(
              updateAlgo({
                companyId: algo.company,
                progress: algo.current_step,
                algoId: algo.id,
                creator: algo.creator,
                calledAt: algo.called_at,
              }),
            );
          }
        });

        dispatch(setLastUpdated(selectedCompany ? selectedCompany?.called_at : null));

        // end interval if processing is completed
        const pendingCompanies = data?.some((x) => x.status === "processing");
        if (!pendingCompanies && fromInterval) {
          onResponse();
          previewHandler();
        }
      })
      .catch(() => {
        if (fromInterval) onResponse();
      });
  };

  // HANDLERS
  const openCancelPreviewHandler = (e, data, companyId) => {
    e.stopPropagation();
    setSelectedAlgo({
      algoId: data?.algoId,
      id: companyId,
    });
    setCancelPreview(true);
  };
  const cancelPreviewHandler = () => {
    setSelectedAlgo(null);
    setCancelPreview(false);
  };

  const openListProgressModal = (companyId) => {
    dispatch(setAlgoPreview({ companyId, preview: true }));
  };

  // HOOKS
  useEffect(() => {
    if (!selectedCompany?.id) return;
    getAlgorithmStatus(selectedCompany.id);
  }, [selectedCompany]);

  useEffect(() => {
    let timer;
    if (isListGenerating) {
      timer = setInterval(() => {
        getAlgorithmStatus(selectedCompany.id, true, () => clearInterval(timer));
      }, 10000);
    }
    return () => clearInterval(timer);
  }, [isListGenerating, selectedCompany, dispatch]);

  return (
    <>
      <Modal
        open={preview && !cancelPreview}
        footer={null}
        width={610}
        className="target-ai-list-modal"
        onCancel={previewHandler}
        closable={false}
      >
        <button className="close-btn" onClick={previewHandler}>
          <Close />
        </button>
        <h2>We're building results for following companies</h2>

        {Object.keys(agloCompanies).map((algoId, index) => {
          const data = agloCompanies[algoId];
          const companyName = userCompanies?.find(
            (x) => x.id === parseInt(algoId),
          )?.company_name;
          if (data.completed) return null;
          const progressWidth = 25 * (data.progress - 1);
          return (
            <div
              className="company-progress-card"
              key={index}
              onClick={() => openListProgressModal(algoId)}
            >
              <div className="thumb">
                <Apartment />
              </div>
              <div className="content">
                <div className="title-box">
                  <h4>{companyName}</h4>
                  {data?.creator && (
                    <button
                      className="cancel-btn"
                      onClick={(e) => openCancelPreviewHandler(e, data, algoId)}
                    >
                      Cancel Request
                    </button>
                  )}
                </div>
                <Tooltip title={`${progressWidth}%`}>
                  <div className="progress-status">
                    <span
                      className="progress-indicator"
                      style={{ width: `${progressWidth + 25}%` }}
                    >
                      <span className="future-progress" />
                      <span className="progress-animation" />
                    </span>
                    <span className="progress" style={{ width: `${progressWidth}%` }} />
                  </div>
                </Tooltip>
              </div>
            </div>
          );
        })}
      </Modal>
      <CancelTargetListModal
        preview={cancelPreview}
        algoId={selectedAlgo?.algoId}
        previewHandler={cancelPreviewHandler}
        selectedCompany={selectedAlgo?.id}
      />
    </>
  );
};

export default TargetListCompaniesProgresstModal;
